import { applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk";

import tralisApp from "./reducers";

import type { Action, UnknownAction } from "redux";
import type { ThunkAction, ThunkDispatch } from "redux-thunk";

import type { ActionType } from "./actions";
import type { AppState } from "./reducers";

/** Extra argument injected into every thunk by `withExtraArgument`. */
export type ThunkExtraArg = unknown;

/**
 * Dispatch type that understands both plain action objects and thunk
 * functions (including the extra `{ t }` argument).
 */
export type AppDispatch = ThunkDispatch<
  AppState,
  ThunkExtraArg,
  Action<ActionType>
>;

/** Convenience alias for typing thunk action creators. */
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  ThunkExtraArg,
  Action<ActionType> & UnknownAction
>;

/** Convenience alias for typing plain action objects. */
export type AppAction = Action<ActionType> & UnknownAction;

const store = createStore(tralisApp, applyMiddleware(thunk));

/** Typed store exposing `AppDispatch` for `dispatch`. */
export type AppStore = { dispatch: AppDispatch } & Omit<
  typeof store,
  "dispatch"
>;

export default store as AppStore;
